import React from 'react';
import styles from './OrderTable.module.scss';
import { XPagination, XTableSelectionCount, XTableHOC, XOKButton } from '@/components/xqxc_ui';
import { message, Table, Tooltip, Modal } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { regFenToYuan } from '@/util/money';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';
import { MenuOutlined } from '@ant-design/icons';
import ButtonPerssion from '@/routes/ButtonPerssion';
import http from '@/assets/api/http';
const { confirm } = Modal;

class OrderTable extends React.Component {

    state = {
        selectedRowKeys: []
    }

    systype = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';

    _adminTableColumns = [
        {
            title: '订单号',
            dataIndex: 'deliveryShowId',
            key: 'deliveryShowId',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(text, () => {
                this.props.tableAction(item.id, 'info', item);
            })
        },
        {
            title: '订单来源',
            dataIndex: 'orderSource',
            key: 'orderSource',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士信息',
            dataIndex: 'riderName',
            key: 'riderName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => this.riderListTooltip(record)
        },
        {
            title: '下单渠道',
            dataIndex: 'orderChannelView',
            key: 'orderChannelView',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发件人',
            dataIndex: 'shipperName',
            key: 'shipperName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '配送地址',
            dataIndex: 'consigneeAddrLabel',
            key: 'consigneeAddrLabel',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        // {
        //     title: '骑士帐号',
        //     dataIndex: 'riderPhone',
        //     key: 'riderPhone',
        //     width: cellWidth.normal,
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        // {
        //     title: '骑士姓名',
        //     dataIndex: 'riderName',
        //     key: 'riderName',
        //     width: cellWidth.normal,
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '下单账号',
            dataIndex: 'userName',
            key: 'userName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '下单账号类型',
            dataIndex: 'userAccountType',
            key: 'userAccountType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发货信息',
            dataIndex: 'shipperPhone',
            key: 'shipperPhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收货信息',
            dataIndex: 'consigneePhone',
            key: 'consigneePhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单实付金额',
            dataIndex: 'payAmount',
            key: 'payAmount',
            width: cellWidth.normal,
            align: 'center',
            render: (text) => (this._renderTextMoneyCell(text))
        },
        {
            title: '小费',
            dataIndex: 'tips',
            key: 'tips',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text) => (this._renderTextMoneyCell(text))
        },
        {
            title: '订单状态',
            dataIndex: 'status',
            key: 'status',
            width: cellWidth.normal,
            align: 'center',
            render: tooltip
        },
        {
            title: '订单类型',
            dataIndex: 'type',
            key: 'type',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单类别',
            dataIndex: 'isZone',
            key: 'isZone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '是否转单',
            dataIndex: 'isTransfer',
            key: 'isTransfer',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '送达是否超时',
            dataIndex: 'isDelay',
            key: 'isDelay',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发单时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '实际送达',
            dataIndex: 'actualDeliverTime',
            key: 'actualDeliverTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运营公司',
            dataIndex: 'opName',
            key: 'opName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付通道',
            dataIndex: 'payAccessType',
            key: 'payAccessType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付方式',
            dataIndex: 'payType',
            key: 'payType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'key',
            key: 'key',
            align: 'center',
            width: '200px',
            fixed: 'right',
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ];

    _withoutColumn = ['订单来源', '下单账号', '下单账号类型'];
    _companyTableColumns = this._adminTableColumns.filter(v => {
        return !this._withoutColumn.includes(v.title);
    })

    riderListTooltip = (record) => {
        return (
            <>
                {
                    record.zonePathList ? <div className={styles.riderInfo}>
                        <span>{record.riderInfo}</span>
                        <Tooltip title={() => this.riderList(record)} color="#fff" placement="right" overlayClassName={styles.riderTooltip}>
                            <MenuOutlined />
                        </Tooltip>
                    </div> : record.riderInfo ? <div>{record.riderInfo}</div> : <div>-</div>
                }
            </>
        )
    }

    riderColumns = [
        {
            title: '骑士姓名',
            dataIndex: 'riderName',
            key: 'riderName',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士手机',
            dataIndex: 'riderPhone',
            key: 'riderPhone ',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '转单时间',
            dataIndex: 'transTime',
            key: 'transTime',
            width: '30%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '事件',
            dataIndex: 'msg',
            key: 'msg',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
    ]

    riderList = (list) => {
        return (
            <div>
                <p className={styles.riderTitle}>订单骑士</p>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.riderPhone}
                    columns={this.riderColumns}
                    dataSource={list.zonePathList}
                    pagination={false}
                    scroll={{ y: true }}
                />
            </div>
        )
    }

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }
    _renderTextMoneyCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {regFenToYuan(text)}
            </div>
        );
    }
    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };

    // 
    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                {(record.status == '配送中' || record.status == '妥投异常') && <ButtonPerssion code='order/distributionorder/ysd' render={(hasPerssion, disabled) => {
                    if (hasPerssion) {
                        return <div className={`${styles.item} ${disabled ? styles.disabled : ''}`} onClick={() => {
                            if (disabled) {
                                message.error('您仅有只读权限，无法继续操作')
                                return;
                            }
                            tableAction(key, 'delivery', record)
                        }}>已送达</div>
                    } else {
                        return null;
                    }
                }} />}

                {['待发布', '待接单', '待取件', '已到取件点', '妥投异常'].includes(record.status) && <ButtonPerssion code='order/distributionorder/td' render={(hasPerssion, disabled) => {
                    if (hasPerssion) {
                        return <div className={`${styles.item} ${disabled ? styles.disabled : ''}`} onClick={() => {
                            if (disabled) {
                                message.error('您仅有只读权限，无法继续操作')
                                return;
                            }
                            tableAction(key, 'chargeback', record)
                        }}>退单</div>
                    } else {
                        return null;
                    }
                }} />}

                <ButtonPerssion code='order/distributionorder/ddrz' render={(hasPerssion, disabled) => {
                    if (hasPerssion) {
                        return <div className={`${styles.item} ${disabled ? styles.disabled : ''}`} onClick={() => {
                            if (disabled) {
                                message.error('您仅有只读权限，无法继续操作')
                                return;
                            }
                            tableAction(key, 'history', record)
                        }}>订单日志</div>
                    } else {
                        return null;
                    }
                }} />

                {['待接单', '待取件', '已到取件点', '配送中'].includes(record.status) && <ButtonPerssion code='order/distributionorder/zpqs' render={(hasPerssion, disabled) => {
                    if (hasPerssion) {
                        return <div className={`${styles.item} ${disabled ? styles.disabled : ''}`} onClick={() => {
                            if (disabled) {
                                message.error('您仅有只读权限，无法继续操作')
                                return;
                            }
                            tableAction(key, 'assign', record)
                        }}>指派骑士</div>
                    } else {
                        return null;
                    }
                }} />}
            </div>
        );
    };

    // 表格复选输入
    _rowSelection = () => {
        const { selectedRowKeys } = this.state;
        return {
            selectedRowKeys,
            onChange: (selectedRowKeys) => {
                this.setState({ selectedRowKeys });
                this.props.tableAction(null, 'batch', [...selectedRowKeys]);
            }
        };
    };

    // 清空表格复选框
    _cleanAllSelected = () => {
        this.setState({ selectedRowKeys: [] });
        this.props.tableAction(null, 'batch', []);
    }

    render() {
        const { selectedRowKeys } = this.state;
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                {/* <XTableSelectionCount selectedNum={selectedRowKeys.length} onClean={this._cleanAllSelected} /> */}
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowSelection={this._rowSelection()}
                    rowKey={record => record.deliveryId}
                    columns={this.systype == 'ADMIN' ? this._adminTableColumns : this._companyTableColumns}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    scrollY: PropTypes.string
};

export default OrderTable;
